import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import AboutPage from './pages/AboutPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderStatusPage from './pages/OrderStatusPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import OrdersPage from './pages/OrdersPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminRoute from './AdminRoute';
import { getCustomer } from './api/client';

class App extends React.Component {
  constructor(props) {
    super(props);
    // cartVersion is bumped whenever an item is added/removed so the
    // Navbar's cart badge re-fetches without prop-drilling a global store.
    // customer mirrors the logged-in account (or null for a guest), read
    // from localStorage on load and updated by login/signup/logout.
    this.state = { cartVersion: 0, customer: getCustomer() };
    this.bumpCart = this.bumpCart.bind(this);
    this.setCustomer = this.setCustomer.bind(this);
  }

  bumpCart() {
    this.setState((prev) => ({ cartVersion: prev.cartVersion + 1 }));
  }

  setCustomer(customer) {
    this.setState({ customer });
  }

  render() {
    const { customer } = this.state;
    return (
      <BrowserRouter>
        <Navbar cartVersion={this.state.cartVersion} customer={customer} onLogout={() => this.setCustomer(null)} />
        <main className="page-content">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/products" element={<ProductsPage onCartChange={this.bumpCart} />} />
            <Route path="/products/:id" element={<ProductDetailPage onCartChange={this.bumpCart} />} />
            <Route path="/cart" element={<CartPage onCartChange={this.bumpCart} />} />
            <Route path="/checkout" element={<CheckoutPage customer={customer} />} />
            <Route path="/order-status" element={<OrderStatusPage />} />

            <Route path="/login" element={<LoginPage onLogin={this.setCustomer} />} />
            <Route path="/signup" element={<SignupPage onLogin={this.setCustomer} />} />
            <Route path="/orders" element={<OrdersPage customer={customer} />} />

            {/* Admin — not linked from the Navbar; only reachable by URL */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route
              path="/admin/dashboard"
              element={<AdminRoute><AdminDashboardPage /></AdminRoute>}
            />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    );
  }
}

export default App;
